<div class="tab-pane" role="tabpanel" id="representante">
    <fieldset id="agregar_representante" class="">
        <div class="step_section">
            <h3 class="form-signin-heading"><strong>Informaci&oacute;n de los Representantes Legales</strong></h3>
            <hr>
            <div class="row" id="row">
                <div class="col-md-12" id="content">

                    <p>Ingrese el RUT para agregar representante legal</p>
                    <div class="form-horizontal">
                        <div class="form-group">
                            
                            <div class="col-sm-12 col-md-4 col-lg-4">
                                <form [formGroup]="rut_rep">
                                    <mat-form-field class="example-full-width" style="width: 100%;">
                                        <input matInput placeholder="Rut" id="rut_rep" name="rut_rep"
                                            formControlName="rut" formatRut [errorStateMatcher]="matcher">
                                        <mat-error *ngIf="rut_rep && rut_rep.controls?.rut.hasError('invalidRut')">
                                            Este rut es <strong>invalido</strong>
                                        </mat-error>
                                    </mat-form-field>
                                </form>
                            </div>

                            <div class="col-sm-12 col-md-4 col-lg-4">
                                <button mat-raised-button color="primary" style="padding-top: 5px" id="b_rut_rep"
                                    [disabled]="!rut_rep.valid" (click)="get_representante(rut_rep.controls.rut.value)">
                                    Agregar Representante
                                    <mat-icon aria-label="icon">add_circle_outline</mat-icon>
                                </button>
                            </div>
                            <div class="col-sm-12 col-md-4 col-lg-4"></div>
                        </div>
                    </div>
                    <!--Detalle del representante-->
                    <div class="datatable_antecedentes">
                        <ngx-datatable class="material expandable" [messages]="''" [rows]="rows" [columnMode]="'force'"
                            [headerHeight]="'auto'" [footerHeight]="'auto'" [rowHeight]="'auto'">
                            <ngx-datatable-column>
                                <ng-template ngx-datatable-header-template>
                                    <span>RUT</span>
                                </ng-template>
                                <ng-template let-row="row" ngx-datatable-cell-template>
                                    {{row.rut}}
                                </ng-template>
                            </ngx-datatable-column>
                            <ngx-datatable-column>
                                <ng-template ngx-datatable-header-template>
                                    <span>NOMBRE</span>
                                </ng-template>
                                <ng-template let-row="row" ngx-datatable-cell-template>
                                    <span>{{row.nombre}}</span><span> {{row.apellido_pat}}</span><span>
                                        {{row.apellido_mat}}</span>
                                </ng-template>
                            </ngx-datatable-column>
                            <ngx-datatable-column>
                                <ng-template ngx-datatable-header-template>
                                    <span>OPCIONES</span>
                                </ng-template>
                                <ng-template let-row="row" let-rowIndex="rowIndex" ngx-datatable-cell-template>
                                    <span (click)="update_representante(row.rut,rowIndex)"
                                        style="padding-right: 5px;"><i class="glyphicon glyphicon-eye-open"></i></span>
                                    <span (click)="delete_representante(rowIndex)"><i
                                            class="glyphicon glyphicon-trash"></i></span>
                                </ng-template>
                            </ngx-datatable-column>

                        </ngx-datatable>
                    </div>
                </div>

            </div>
        </div>
    </fieldset>

    <!--Material dialog modal-->
    <ng-template #openModal>
        <h2 mat-dialog-title>Ingresar informaci&oacute;n del representante</h2>
        <mat-dialog-content class="text-center">
            <div class="form-horizontal">
                <div class="alert alert-info" role="alert">
                    <i class="fa fa-info-circle" aria-hidden="true"></i>
                    <strong> Debe ingresar la informacion del representante</strong>, su solicitud pasar&aacute; <br>por un
                    proceso de verificaci&oacute;n del representante ingresado. <br>
                    <i class="fa fa-exclamation-circle" aria-hidden="true"></i>
                    <strong> Campos obligatorios marcados con un (<span style="color: red">*</span>)</strong>
                </div>

                <div class="form-group">
                    <div class="col-md-2"></div>
                    <div class="col-md-8">
                        <mat-form-field class="example-full-width" style="width: 100%">
                        <input matInput id="rut_represent" name="rut_represent" type="text" placeholder="RUT"
                            class="" [(ngModel)]="representante.rut" readonly>
                        </mat-form-field>
                    </div>
                    <div class="col-md-2"></div>
                </div>

                <div class="form-group">
                    <div class="col-md-2"></div>
                    <div class="col-md-8">
                        <mat-form-field class="example-full-width" style="width: 100%">
                        <input matInput id="nombre" name="nombre" type="text" placeholder="Nombre" class=""
                            [(ngModel)]="representante.nombre">
                        </mat-form-field>
                    </div>
                    <div class="col-md-2"></div>
                </div>
                <div id="hide-rep-enterprise">
                    <div class="form-group">
                        <div class="col-md-2"></div>
                        <div class="col-md-8">
                            <mat-form-field class="example-full-width" style="width: 100%">
                                <input matInput id="apellido_pat" name="apellido_pat" type="text" placeholder="Apellido Paterno"
                                class="" [(ngModel)]="representante.apellido_pat">
                            </mat-form-field>
                        </div>
                        <div class="col-md-2"></div>
                    </div>
                    <div class="form-group">
                        <div class="col-md-2"></div>
                        <div class="col-md-8">
                            <mat-form-field class="example-full-width" style="width: 100%">
                                <input matInput id="apellido_mat" name="apellido_mat" type="text" placeholder="Apellido Materno"
                                class="" [(ngModel)]="representante.apellido_mat">
                            </mat-form-field>
                        </div>
                        <div class="col-md-2"></div>
                    </div>
                </div>
                <div hidden="hidden">
                    <div class="form-group">
                        <div class="col-md-1"></div>
                        <label class="col-md-2 control-label" for="direccion">Direcci&oacute;n: Calle(<span
                                style="color: red">*</span>)</label>
                        <div class="col-md-3">
                            <input id="direccion" name="direccion" type="text" placeholder="Calle"
                                class="form-control input-md" [(ngModel)]="representante.direccion">
                        </div>
                        <label class="col-md-2 control-label" for="direccion_num">Direcci&oacute;n: Numero(<span
                                style="color: red">*</span>)</label>
                        <div class="col-md-3">
                            <input id="direccion_num" name="direccion_num" type="text" placeholder="Numero"
                                class="form-control input-md" [(ngModel)]="representante.direccion_num">
                        </div>
                    </div>
                    <div class="form-group">
                        <div class="col-md-1"></div>
                        <label class="col-md-2 control-label" for="direccion_complemento">Direcci&oacute;n:
                            Complemento</label>
                        <div class="col-md-3">
                            <input id="direccion_complemento" name="direccion_complemento" type="text"
                                placeholder="Complemento" class="form-control input-md"
                                [(ngModel)]="representante.direccion_complemento">
                        </div>
                        <div class="col-md-5">
                            <label class="col-md-5 control-label" for="comuna">Comuna(<span style="color: red">*</span>)
                            </label>
                            <div class="col-md-7">
                                <mat-form-field class="example-full-width">
                                    <input type="text" id="Com_nombre" name="Com_nombre" aria-label="Nombre" matInput
                                        [formControl]="nombreComuna" [matAutocomplete]="auto"
                                        [(ngModel)]="representante.comuna">
                                    <mat-autocomplete #auto="matAutocomplete">
                                        <mat-option *ngFor="let option of filteredOptions | async" [value]="option">
                                            {{option}}
                                        </mat-option>
                                    </mat-autocomplete>
                                </mat-form-field>
                                <!-- <input id="comuna" name="comuna" type="text" placeholder="Comuna" [(ngModel)]="propietario.comuna" class="form-control input-md"> -->
                            </div>
                            <div class="col-md-2"></div>
                        </div>
                    </div>
                    <div class="form-group">
                        <div class="col-md-1"></div>
                        <label class="col-md-2 control-label" for="direccion_completa">Direcci&oacute;n:
                            Completa</label>
                        <div class="col-md-3">
                            <input id="direccion_completa" name="direccion_completa" type="text"
                                placeholder="Complemento" class="form-control input-md"
                                [(ngModel)]="representante.direccion_completa">
                        </div>
                        <label class="col-md-2 control-label"></label>
                        <div class="col-md-3">

                        </div>
                    </div>
                </div>
                <div class="form-group">
                    <div class="col-md-2"></div>
                    <div class="col-md-8">
                        <mat-form-field class="example-full-width" style="width: 100%">
                            <input matInput id="fono_represent" name="fono_represent" type="text" placeholder="Tel&eacute;fono"
                            class="" [(ngModel)]="representante.fono">
                        </mat-form-field>
                    </div>
                    <div class="col-md-2"></div>
                </div>
                <form [formGroup]="mail_rep">
                    <div class="form-group">
                        <div class="col-md-2"></div>
                        <div class="col-md-8">
                            <mat-form-field style="width: 100%;" floatLabel="never">
                                <input matInput type="email" placeholder="Email" id="email_propiet" name="email_propiet"
                                    formControlName="mail" [(ngModel)]="representante.mail"
                                    class="">
                                <mat-error *ngIf="mail_rep.controls.mail.errors?.required">Email requerido
                                </mat-error>
                                <mat-error *ngIf="mail_rep.controls.mail.errors?.pattern">Formato incorrecto.
                                    Ej:
                                    correo@servidor.dominio. </mat-error>
                                <mat-error *ngIf="mail_rep.controls.mail.errors?.maxlength">Excede el máximo de
                                    caracteres
                                    (50). </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-md-2"></div>
                    </div>
                </form>
                <!--  <div class="form-group">
                    <label class="col-md-4 control-label" for="email_represent">Email(<span style="color: red">*</span>)</label>
                    <div class="col-md-6">
                        <input id="email_represent" name="email_represent" type="email" placeholder="mail@ejemplo.com" class="form-control input-md" [(ngModel)]="representante.mail">
                    </div>
                    <div class="col-md-2"></div>
                </div> -->
            </div>
        </mat-dialog-content>
        <mat-dialog-actions align="center">
            <button class="btn" matDialogClose mat-raised-button color="warn" id="clean_ingreso_represent" (click)="cleanData()"
                data-dismiss="modal">Cancelar</button>
            <button class="btn" mat-raised-button color="primary" id="ingreso_represent" (click)="saveRepresentante()"
                [disabled]="!representante.rut || !representante.nombre || !representante.mail || mail_rep.status == 'INVALID'">Ingresar
                Representante
                <i class="fa fa-user-o" aria-hidden="true"></i></button>
        </mat-dialog-actions>
    </ng-template>
    <!--End Material dialog modal-->
    <!-- Modal -->
    <a class="label label-success" data-toggle="modal" #openModal data-target="#rep_modal"
        id="representante_manual_open" hidden></a>
    <div class="modal fade" id="rep_modal" role="dialog" aria-labelledby="rep_modal_label" aria-hidden="true"
        data-keyboard="false" data-backdrop="static">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <button type="button" class="close" data-dismiss="modal" aria-hidden="true">×</button>
                    <h4 class="modal-title" id="rep_modal_label">
                        Ingresar informaci&oacute;n del representante
                    </h4>
                </div>
                <div class="modal-body" id="rep_modal_body">

                    <div class="form-horizontal">
                        <div class="alert alert-info" role="alert">
                            <i class="fa fa-info-circle" aria-hidden="true"></i>
                            <strong> Debe ingresar la informacion del representante</strong>, su solicitud pasar&aacute;
                            por un proceso de verificaci&oacute;n del representante ingresado.
                        </div>
                        <div class="form-group">
                            <label class="col-md-4 control-label" for="rut_represent">RUT</label>
                            <div class="col-md-6">
                                <input id="rut_represent" name="rut_represent" type="text" placeholder="RUT"
                                    class="form-control input-md" [(ngModel)]="representante.rut" readonly>
                            </div>
                            <div class="col-md-2"></div>
                        </div>
                        <div class="form-group">
                            <label class="col-md-4 control-label" for="nombre">Nombre</label>
                            <div class="col-md-6">
                                <input id="nombre" name="nombre" type="text" placeholder="Nombre"
                                    class="form-control input-md" [(ngModel)]="representante.nombre">
                            </div>
                            <div class="col-md-2"></div>
                        </div>
                        <div id="hide-rep-enterprise">
                            <div class="form-group">
                                <label class="col-md-4 control-label" for="apellido_pat">Apellido Paterno</label>
                                <div class="col-md-6">
                                    <input id="apellido_pat" name="apellido_pat" type="text"
                                        placeholder="Apellido Paterno" class="form-control input-md"
                                        [(ngModel)]="representante.apellido_pat">
                                </div>
                                <div class="col-md-2"></div>
                            </div>
                            <div class="form-group">
                                <label class="col-md-4 control-label" for="apellido_mat">Apellido Materno</label>
                                <div class="col-md-6">
                                    <input id="apellido_mat" name="apellido_mat" type="text"
                                        placeholder="Apellido Materno" class="form-control input-md"
                                        [(ngModel)]="representante.apellido_mat">
                                </div>
                                <div class="col-md-2"></div>
                            </div>
                        </div>
                        <div hidden="hidden">
                            <div class="form-group">
                                <div class="col-md-1"></div>
                                <label class="col-md-2 control-label" for="direccion">Direcci&oacute;n: Calle</label>
                                <div class="col-md-3">
                                    <input id="direccion" name="direccion" type="text" placeholder="Calle"
                                        class="form-control input-md" [(ngModel)]="representante.direccion">
                                </div>
                                <label class="col-md-2 control-label" for="direccion_num">Direcci&oacute;n:
                                    Numero</label>
                                <div class="col-md-3">
                                    <input id="direccion_num" name="direccion_num" type="text" placeholder="Numero"
                                        class="form-control input-md" [(ngModel)]="representante.direccion_num">
                                </div>
                            </div>
                            <div class="form-group">
                                <div class="col-md-1"></div>
                                <label class="col-md-2 control-label" for="direccion_complemento">Direcci&oacute;n:
                                    Complemento</label>
                                <div class="col-md-3">
                                    <input id="direccion_complemento" name="direccion_complemento" type="text"
                                        placeholder="Complemento" class="form-control input-md"
                                        [(ngModel)]="representante.direccion_complemento">
                                </div>
                                <label class="col-md-2 control-label" for="comuna">Comuna</label>
                                <div class="col-md-3">
                                    <input id="comuna" name="comuna" type="text" placeholder="Comuna"
                                        class="form-control input-md" [(ngModel)]="representante.comuna">
                                </div>
                            </div>
                            <div class="form-group">
                                <div class="col-md-1"></div>
                                <label class="col-md-2 control-label" for="direccion_completa">Direcci&oacute;n:
                                    Completa</label>
                                <div class="col-md-3">
                                    <input id="direccion_completa" name="direccion_completa" type="text"
                                        placeholder="Complemento" class="form-control input-md"
                                        [(ngModel)]="representante.direccion_completa">
                                </div>
                                <label class="col-md-2 control-label"></label>
                                <div class="col-md-3">

                                </div>
                            </div>
                        </div>
                        <div class="form-group">
                            <label class="col-md-4 control-label" for="fono_represent">Tel&eacute;fono</label>
                            <div class="col-md-6">
                                <input id="fono_represent" name="fono_represent" type="text"
                                    placeholder="Tel&eacute;fono" class="form-control input-md"
                                    [(ngModel)]="representante.fono">
                            </div>
                            <div class="col-md-2"></div>
                        </div>
                        <div class="form-group">
                            <label class="col-md-4 control-label" for="email_represent">Email</label>
                            <div class="col-md-6">
                                <input id="email_represent" name="email_represent" type="email"
                                    placeholder="mail@ejemplo.com" class="form-control input-md"
                                    [(ngModel)]="representante.mail">
                            </div>
                            <div class="col-md-2"></div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-sm btn-danger" id="clean_ingreso_represent"
                        (click)="cleanData()" data-dismiss="modal">Cancelar</button>
                    <button type="button" class="btn btn-sm btn-primary" id="ingreso_represent"
                        (click)="saveRepresentante()">Ingresar Representante <i class="fa fa-user-o"
                            aria-hidden="true"></i></button>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="separator"></div>